import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  position: relative;
  display: block;

  .slide-image {
    width: 100%;
    display: block;
  }

  .gradient-overlay {
    width: 100%;
    height: 50%;
    position: absolute;
    z-index: 5;
    bottom: 0;
    left: 0;

    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.7)
    );
    pointer-events: none;
  }

  .content-link {
    position: absolute;
    bottom: 20px; 
    left: 1rem;   
    z-index: 10;

    display: flex;
    flex-direction: column-reverse; 
    align-items: center; 
    gap: 15px; 
  }

  .qrcode-image {
    width: 130px; 
    height: 130px;

    background-color: #fff; 
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    padding: 5px; 
    box-sizing: border-box; 
  }

  .btn-slider {
    background-color: ${({ theme }) => theme.colors.primary};
    border: none;
    border-radius: 8px;
    transition: background-color 0.3s ease, transform 0.2s ease;
    padding: 0;
    cursor: pointer;

    &:hover {
      background-color: #fe5000d5;
    }

    .slider-link {
      display: block;
      padding: 25px 25px;

      font-family: "Open Sans", sans-serif;
      color: white;
      font-size: 1rem;
      font-weight: bold;
      text-decoration: none;
      text-align: center;
      white-space: nowrap;
    }
  }

  @media (max-width: 1280px) {
     .gradient-overlay {
      display: none;
    }
    .content-link {
      width: 100%; 
      position: static; 
      z-index: 10;
      
      display: flex;
      flex-direction: column-reverse; 
      align-items: center; 
      gap: 15px; 
      margin-top: 20px;
    }

    .qrcode-image {
      position: static; 
      left: auto;
      bottom: auto;
      
      width: 120px; 
      height: 120px;
      border-radius: 4px;
      padding: 4px;
    }
    
    .btn-slider {
      position: static;
      bottom: auto;
      left: auto;
      transform: none; 
      display: flex;
      justify-content: center;
      align-items: center;

      width: 55%;
      max-width: 350px; 

      .slider-link {
        padding: 10px 20px;
        font-size: 12px;
      }
    }
  }
`;
